<template>
  <el-dialog title="填写进度分享时间"
             :visible.sync="dialogVisible"
             width="50%"
             top="20px"
             :close-on-click-modal="false"
             destroy-on-close
             @closed="progressAfterDialogClosed">
    <el-form label-width="180px">
      <el-form-item :label="`第${nextSeqNo}次进度分享时间`">
        <el-date-picker v-model="newMeetingTime"
                        type="datetime"
                        :picker-options="dateTimeLteTodayOptions"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        placeholder="请选择进度分享的时间"
                        :default-time="defaultTime"
                        clearable>
        </el-date-picker>
      </el-form-item>

      <el-form-item v-if="submittedMeetingList.length > 0"
                    label="历史记录">
        <template v-for="(item, index) in submittedMeetingList">
          <div v-if="item.hasOwnProperty('submit_admin_id')">
            <el-tag type="">第 {{ item.seq_no }} 次</el-tag>
            <span>
              <i class="el-icon-time"></i>
              {{ item.share_meeting_time }}丨填写人: {{ item.submit_admin_name }}
            </span>
          </div>
        </template>
      </el-form-item>

    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit">提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import projectMixins from '@views/project/project.mixins'

export default {
  mixins: [userWorkInfoMixin, projectMixins],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '0',
    },
    fullNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      form: {},
      submittedMeetingList: [],
      newMeetingTime: null,
      defaultTime: '00:00:00',
    }
  },
  created () {},
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      },
    },
    nextSeqNo () {
      const list = this.submittedMeetingList
      return list.length > 0 ? list[list.length - 1].seq_no + 1 : 1
    },
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.initAttr(this.fullNode.project_node || {})
        }
      },
      immediate: true,
    },
  },
  methods: {
    initAttr (projectNode) {
      this.submittedMeetingList = _.get(projectNode, 'node_result.share_meeting_list', []).map(item => ({...item}))
      this.newMeetingTime = null

      const now = new Date()
      const hh = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      this.defaultTime = `${hh}:${mm}:00`
    },
    async onSubmit () {
      const meetingList = [...this.submittedMeetingList]
      if (!this.newMeetingTime) {
        this.$message.error('第' + this.nextSeqNo + '次进度分享时间不得留空')
        return
      }
      meetingList.push({
        seq_no: this.nextSeqNo,
        share_meeting_time: this.newMeetingTime ? this.newMeetingTime + ':00' : null,
      })

      const params = {
        id: this.projectId,
        share_meeting_list: meetingList
      }
      await this.withLoading(async () => {
        try {
          const res = await request.common('addShareMeetingTimeApi', params)

          this.progressDialogAfterSubmitSuccess(res.data)
          this.$message.success('进度分享时间保存成功')
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        }
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/project/components/ProgressShareMeetingDialog.vue